import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule } from '@angular/forms';

import {
    EuiAutocompleteComponent,
    EuiAutocompleteAppendContentDirective,
    EuiAutocompletePrependContentDirective,
} from './eui-autocomplete.component';
import { EuiChipListModule } from '../eui-chip-list/eui-chip-list.module';
import { EuiChipModule } from '../eui-chip/eui-chip.module';
import { EuiIconModule } from '../atoms';

@NgModule({
    imports: [
        CommonModule,
        MatChipsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        EuiChipListModule,
        EuiChipModule,
        EuiIconModule,
    ],
    declarations: [
        EuiAutocompleteComponent,
        EuiAutocompleteAppendContentDirective,
        EuiAutocompletePrependContentDirective,
    ],
    exports: [
        EuiAutocompleteComponent,
        EuiAutocompleteAppendContentDirective,
        EuiAutocompletePrependContentDirective,
    ],
})
export class EuiAutocompleteModule { }
